import React, { createContext, useContext, useState } from "react";
import { apiRoutes, routes } from '../routes/routes';
import api from '../api';

const ConversationsContext = createContext();


// Hook pour l'utiliser plus facilement
export const useConversationsContext = () => useContext(ConversationsContext);

export const ConversationsProvider = ({ children }) => {
    const [conversations, setConversations] = useState([]);

    const loadUserConversations = async () => {

        try {
            const response = await api.get(
            apiRoutes.conversations
        );
            const response_conv = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            setConversations(response_conv);
        } catch (err) {

        }
    };

    const addUserConversation= (newConversation) => {
        setConversations((prev) => [newConversation, ...prev]);
    };

    return (
        <ConversationsContext.Provider value={{ conversations, setConversations, loadUserConversations, addUserConversation }}>
            {children}
        </ConversationsContext.Provider>
    );
};